import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { RecordingContext } from "../pages/RecordingPage";
import { TextArea, Button, Segment, Header } from "semantic-ui-react";
import { MAX_TEXT_LENGTH } from "../../constants";

const RecordingText = () => {
  const [editable, setEditable] = useState(false);
  const { recording, updateRecording } = useContext(RecordingContext);
  const [text, setText] = useState();
  useEffect(() => {
    setText(recording.text);
    setEditable(false);
  }, [recording]);
  const onSave = () => {
    setEditable(false);
    if (text !== recording.text) updateRecording({ ...recording, text: text });
  };
  return (
    <div style={{ marginBottom: "50px" }}>
      {editable && (
        <EditTextForm
          text={text}
          onChange={(e) => setText(e.target.value)}
          onSave={onSave}
        />
      )}
      {!editable && !text && (
        <AddTextButton onClick={() => setEditable(true)} />
      )}
      {!editable && text && (
        <TextSegment text={text} onClick={() => setEditable(true)} />
      )}
    </div>
  );
};

const linkStyle = {
  float: "right",
  backgroundColor: "transparent",
  border: "none",
  display: "inline",
  margin: "0",
  padding: "0",
  cursor: "pointer",
  color: "grey",
  textDecoration: "underline",
};

const AddTextButton = ({ onClick }) => (
  <button style={linkStyle} onClick={onClick}>
    Add Text
  </button>
);

AddTextButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const EditTextForm = ({ text, onChange, onSave }) => (
  <>
    <TextArea
      rows={4}
      value={text}
      style={{ width: "100%", height: "100%" }}
      onChange={onChange}
      maxLength={MAX_TEXT_LENGTH}
    />
    <Button
      primary
      floated="right"
      content="Save"
      size="small"
      onClick={onSave}
    />
  </>
);

EditTextForm.propTypes = {
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

const TextSegment = ({ text, onClick }) => (
  <>
    <Segment>
      <Header as="h2" color="grey" style={{ textAlign: "center" }}>
        {text}
      </Header>
    </Segment>
    <button style={linkStyle} onClick={onClick}>
      Edit Text
    </button>
  </>
);

TextSegment.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RecordingText;
